import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class UploadService {

  private baseUrl = 'https://upload.icheck.com.vn';
  private baseUrl2 = 'https://apis.icheck.vn/upload/image/v1';

  constructor(private http: HttpClient) { }

  public postImg(file: any): Observable<any> {
    const body = new FormData();
    body.append('my_field', 'file');
    body.append('my_file', file)
    return this.http.post(`${this.baseUrl}/upload/stream`, body);
  }

}
